export default "__VITE_ASSET__01988b93__"